export const getProto = (location) => {
  const params = new URLSearchParams(location);
  if (!params.has("proto")) {
    return null;
  }

  return params.get("proto");
};

export const getKind = (location) => {
  const params = new URLSearchParams(location);
  if (!params.has("kind")) {
    return null;
  }

  return params.get("kind");
};

export const getScreen = (location) => {
  const params = new URLSearchParams(location);
  if (!params.has("screen")) {
    return null;
  }

  return params.get("screen");
};

